<template>
    <div class="discover">
        <link rel="preload" as="image" :href="slides[0].background" />

        <Slider :slides="slides" :slidesReady="slidesReady"></Slider>

        <!-- not logged in -->
        <template v-if="!user">
            <!-- opportunities -->
            <div v-if="opportunities.length > 0 && opportunitiesLoaded">
                <div class="container">
                    <h1>
                        <translate>opportunities</translate>
                    </h1>
                </div>

                <div class="spacer spacer--50"></div>

                <WorkoutList :workouts="opportunities"></WorkoutList>

                <div class="spacer spacer--50"></div>
            </div>

            <div class="container">
                <h1>
                    <translate>workouts</translate>
                    <span class="up-text text text--large">12</span>
                </h1>
            </div>
            

            <div class="spacer spacer--50"></div>

            <WorkoutList :workouts="workouts"></WorkoutList>

            <div class="spacer spacer--50"></div>

            <div class="container">
                <router-link :to="{name: 'Login'}">
                    <div class="discover__more">
                        <div class="discover__more__inner">
                            <div class="discover__more__text">
                                <strong v-translate>login_now</strong> <translate>for_more_workouts</translate>
                            </div>
                            <puma-button icon="profile" type="light" v-translate>login</puma-button>
                        </div>
                    </div>
                </router-link>
            </div>

           
        </template>

        <!-- logged in -->
        <template v-else>

            <div v-if="opportunitiesLoaded">
                <div v-for="section in opportunities.sections" :key="section.id">
                    <div v-if="section.style === 'card'">
                        <WorkoutPreview v-if="oppSections[section.id] && oppSections[section.id].length > 0" :title="section.title" :workouts="oppSections[section.id]" :contentId="section.id"></WorkoutPreview>
                    </div>
                    <div v-else-if="section.style === 'circle'">
                        <TrainerPreview v-if="oppSections[section.id] && oppSections[section.id].length > 0" :trainers="oppSections[section.id]" :title="section.title"></TrainerPreview>
                    </div>
                </div>
            </div>

            <div v-else class="module module--space-default">
                <div class="discover__loader">
                    <Loader></Loader>
                </div>
            </div>
        </template>

        <!-- PIXLEE CONTAINER -->
        <div class="module module--space-default">
            <div class="container">
                <div id="pixlee_container"></div>
            </div>
        </div>


        <div class="container">
            <div class="discover__banners">
                <div class="discover__banners__item">
                    <BannerApp></BannerApp>
                </div>
                <div class="discover__banners__item">
                    <BannerAd type="light"></BannerAd>
                </div>
            </div>
        </div>

        <div class="spacer spacer--150"></div>

        <Footer></Footer>
    </div>
</template>

<script>
import * as api from '../api'
import { mapGetters } from "vuex"

import WorkoutList from "@/components/WorkoutList.vue";
import BannerAd from "@/components/BannerAd.vue"
import BannerApp from "@/components/BannerApp.vue"
import Slider from "@/components/Slider.vue"
import Footer from "@/components/Footer.vue"
import TrainerPreview from "@/components/TrainerPreview.vue"
import WorkoutPreview from "@/components/WorkoutPreview.vue"

import {addTrackingObject} from "@/utils/tracking"

export default {
    name: "Discover",
    components: {
        WorkoutList,
        BannerAd,
        Slider,
        Footer,
        BannerApp,
        TrainerPreview,
        WorkoutPreview,
    },
    data() {
        return {
            slidesReady: false,
            slides: [
                {
                    background: require('@/assets/img/slide_1.jpg'),
                    title: this.$gettext('home_slide_1_title'),
                    subtitle: this.$gettext('home_slide_1_subtitle'),
                    intro: this.$gettext('home_slide_1_intro'),
                    description: this.$gettext('home_slide_1_description'),
                    downloadApp: this.$gettext('download_the_app_now'),
                    mergeTitle: true,
                    appButtons: [
                        {
                        link: 'https://apps.apple.com/us/app/pumatrac-training-running/id698298978',
                        image: require('@/assets/img/appstore.svg'),
                        title: this.$gettext('download_on_app_store'),
                        type: 'apple'
                        },
                        {
                        link: 'https://play.google.com/store/apps/details?id=com.pumapumatrac',
                        image: require('@/assets/img/play-store.svg'),
                        title: this.$gettext('download_on_google_play'),
                        type: 'android'
                        },
                    ]
                },{
                    background: require('@/assets/img/slide_2.jpg'),
                    image: require('@/assets/img/gadgets.png'),
                    title: this.$gettext('home_slide_2_title'),
                    subtitle: this.$gettext('home_slide_2_subtitle'),
                    description: this.$gettext('home_slide_2_description'),
                    downloadApp: this.$gettext('download_the_app_now'),
                    textCenter: true,
                    appButtons: [
                        {
                        link: 'https://apps.apple.com/us/app/pumatrac-training-running/id698298978',
                        image: require('@/assets/img/appstore.svg'),
                        title: this.$gettext('download_on_app_store'),
                        type: 'apple'
                        },
                        {
                        link: 'https://play.google.com/store/apps/details?id=com.pumapumatrac',
                        image: require('@/assets/img/play-store.svg'),
                        title: this.$gettext('download_on_google_play'),
                        type: 'android'
                        },
                    ]
                },
                // {
                //     background: require('@/assets/img/slider_3.jpg'),
                //     title: this.$gettext('home_slide_3_title'),
                //     subtitle: this.$gettext('home_slide_3_subtitle'),
                //     mergeTitle: true,
                //     intro: this.$gettext('home_slide_3_intro'),
                //     description: this.$gettext('home_slide_3_description'),
                //     workout: true,
                // },
            ],
            workouts: [],
            sliderWorkoutIds: [
                '7f8aaf4a-7ada-4f75-86cf-92e4e2ac728d'
            ],
            allWorkouts: [],
            opportunities: false,
            opportunitiesLoaded: false,
            oppSections: {},
            pixleeLoaded: false,
        }
    },
    mounted () {
        this.fetchData();
        this.getOpportunities()
        setTimeout(() => {
            this.initPixlee()
        }, 10);

        addTrackingObject({subSection: "home", screenName: "opportunities"}, {type: "home", value: "web_landing_page"});
    },
    computed: {
        // ...mapGetters(['user', 'staticWorkoutIds']), //return this after christmas
        ...mapGetters(['user', 'staticWorkouts', 'staticWorkouts']),
    },
    methods: {
        initPixlee() {
            if(!this.pixleeLoaded && typeof Pixlee === 'undefined') {
                let pixleeScript = document.createElement('script')
                pixleeScript.setAttribute('src', 'https://assets.pxlecdn.com/assets/pixlee_widget_1_0_0.js')
                document.body.appendChild(pixleeScript)

                window.PixleeAsyncInit = function() {
                    Pixlee.init({apiKey:'ySWccITl1I4L66al8tWm'});
                    Pixlee.addSimpleWidget({widgetId:2635749, setMetaTags:true, subscribedEvents: ['widgetNumPhotos','photoOpened','ctaClicked','widgetLoaded']});
                    this.pixleeLoaded = true
                };
            } else {
                Pixlee.addSimpleWidget({widgetId:2635749, setMetaTags:true, subscribedEvents: ['widgetNumPhotos','photoOpened','ctaClicked','widgetLoaded']});
                Pixlee.resizeWidget()
            }
        },
        async fetchData() {
            try {
                const response = await api.workout.all();

                this.allWorkouts = response.data.data

                response.data.data.forEach((w) => {
                    // if(this.staticWorkoutIds.indexOf(w.id) >= 0) { //return this after christmas
                    if(this.staticWorkouts.indexOf(w.id) >= 0) { //remove this after christmas
                        this.workouts.push(w);
                    }
                    if(this.sliderWorkoutIds.indexOf(w.id) >= 0) {
                        w.alternateImage = require('@/assets/img/slider_3.jpg')
                        w.sTitle = this.$gettext('home_slide_3_title')
                        w.sSubtitle = this.$gettext('home_slide_3_subtitle')
                        w.sIntro = this.$gettext('home_slide_3_intro')
                        w.sDescription = this.$gettext('home_slide_3_description')
                        w.mergeTitle = true;
                        this.slides.push(w)
                        console.log(this.slides);

                    }
                });

                setTimeout(() => {
                    this.slidesReady = true
                }, 100);
            } catch (error) {
                console.error(error);
            }
        },
        async getOpportunities() {
            try {
                const response = this.user ? await api.opportunities.lists() : await api.opportunities.global()
                const opportunitiesResponse = response.data.data
                this.opportunities = opportunitiesResponse

                if(opportunitiesResponse && this.user) {
                    const sections = opportunitiesResponse.sections
                    
                    sections.map(async section => {
                        const sectionResponse = await api.opportunities.lists({sectionType : section.id})
                        let sectionData = sectionResponse.data.data
                        // merge notification headers into foryou section
                        // if(section.id === 'foryou') {
                        //     sectionData = this.opportunities.notifications.concat(sectionData);
                        // }
                        this.$set(this.oppSections, section.id, sectionData)
                    })

                    this.opportunitiesLoaded = true
                } else {
                     this.opportunitiesLoaded = true
                }
            } catch (error) {
                console.error(error);
            }
        },
    }
}
</script>

<style scoped lang="scss">
.discover {
    h1 {
        padding-top: 10px;
    }

    &__more {
        padding: 0 6px;

        &__inner {
            border-radius: 4px;
            background: black;
            color: white;
            padding: 40px 20px 30px;
            text-align: center;

            @include mq($until: tablet) {
                padding: 35px 30px 30px;
            }
        }

        &__text {
            font-size: $puma-size-font-xl;
            margin-bottom: 10px;

            @include mq($until: tablet) {
                font-size: $puma-size-font-lg;
            }
        }
    }

    &__banners {
        @include mq(tablet-landscape) {
            display: flex;
        }

        &__item {
            &:not(:last-child) {
                margin-bottom: 12px;
            }
            @include mq(tablet-landscape) {
                width: 50%;
                margin-bottom: 0 !important;
            }
        }
    }

    &__loader {
        display: flex;
        justify-content: center;
    }
}
</style>